import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useInterval } from 'usehooks-ts'
import {
  LargeButton,
  Button as NormalButton,
  useButtonHandlers,
} from '../../../../elements/controls/index.js'
import { Row } from '../../../../elements/layout/index.js'
import messages from '../../messages.js'

export const ButtonRow = styled(Row)`
  justify-content: flex-end;
  margin-top: ${(props) => props.theme.spacing.larger}px;
`

export const NextEpisode = ({ nextEpisode, onWatchCredits, size = 'large' }) => {
  const { handlers } = useButtonHandlers()

  const [countDown, setCountDown] = useState(10)

  useInterval(() => setCountDown((count) => Math.max(count - 1, 0)), countDown ? 1000 : null)

  useEffect(() => {
    if (countDown === 0) {
      handlers.playFeature(nextEpisode, 'replace')
    }
  }, [countDown, handlers, nextEpisode])

  const Button = size === 'large' ? LargeButton : NormalButton

  return (
    <ButtonRow>
      <Button
        variant="primary"
        intlMsg={messages.nextEpisodeIn}
        values={{ seconds: countDown }}
        onPress={() => handlers.playFeature(nextEpisode, 'replace')}
        mr="medium"
      />
      <Button
        variant="white"
        intlMsg={messages.watchCredits}
        titleColor="black"
        onPress={onWatchCredits}
      />
    </ButtonRow>
  )
}
